var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('header',{staticClass:"header header1 clearfix",attrs:{"id":"header"}},[_c('top-nav')],1),_c('main',{attrs:{"id":"main"}},[_c('router-view')],1),[_c('footer-content')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }